import React from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {Card, CardActionArea, Grid, CardContent, Typography} from "@mui/material";
import {useHistory} from "react-router-dom";
import {LinaArrowRight} from "~/ui/icons";
import {useFinance} from "~/apps/packages/finance/hooks";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


const Item = ({title, onClick}) => (
    <Card elevation={4} style={{borderRadius: 8, boxShadow: "0px 4px 24px rgba(104, 117, 130, 0.09)"}}>
        <CardActionArea onClick={onClick}>
            <CardContent style={{padding: "16px", paddingRight: "8px"}}>
                <Grid container alignItems="center" wrap="nowrap">
                    <Typography variant="screenText" display="block" width="100%">
                        {title}
                    </Typography>
                    <LinaArrowRight color="additionalSecondary"/>
                </Grid>
            </CardContent>
        </CardActionArea>
    </Card>
)


export const IndexPage = () => {
    const history = useHistory();
    const {loading} = useFinance();

    const navigateToOnClick = (name) => (e) => {
        history.push(name);
    }

    return (
        <TitleLayout title="Финансы">
            <LoadingBox loading={loading}>
                {!loading && (
                    <Grid container direction="column" rowSpacing="8px" marginTop={1} wrap="nowrap">
                        <Grid item>
                            <Item title="Договоры" onClick={navigateToOnClick("contracts")}/>
                        </Grid>
                        <Grid item>
                            <Item title="Сверка" onClick={navigateToOnClick("reconciliation")}/>
                        </Grid>
                        <Grid item>
                            <Item title="Тарифные соглашения" onClick={navigateToOnClick("tariffs")}/>
                        </Grid>
                    </Grid>
                )}
            </LoadingBox>
        </TitleLayout>
    )
}
